// Common timezones list
export const COMMON_TIMEZONES = [
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
  'America/Phoenix',
  'America/Anchorage',
  'Pacific/Honolulu',
  'America/Toronto',
  'America/Vancouver',
  'America/Mexico_City',
  'Europe/London',
  'Europe/Paris',
  'Europe/Berlin',
  'Europe/Madrid',
  'Europe/Rome',
  'Europe/Athens',
  'Europe/Moscow',
  'Asia/Dubai',
  'Asia/Kolkata',
  'Asia/Shanghai',
  'Asia/Tokyo',
  'Asia/Hong_Kong',
  'Asia/Singapore',
  'Australia/Sydney',
  'Australia/Melbourne',
  'Pacific/Auckland',
  'UTC',
]

// Business hours configuration
export const BUSINESS_HOURS = {
  start: 9,
  end: 17,
}

// Default meeting durations in minutes
export const MEETING_DURATION_DEFAULT = 60
export const MEETING_DURATION_SUGGESTED = 30

// Time slot configuration
export const SLOT_INTERVAL = 15

// Maximum days to search for available meeting slots
export const MAX_DAYS_TO_SEARCH = 14

// Number of suggested times to show
export const SUGGESTED_TIMES_COUNT = 5
